import { AxiosResponse } from 'axios';

export type JsonResponse<T> = {
  data: T;
};

export const getDataFromResponse = <T>(response: AxiosResponse<JsonResponse<T>>): T =>
  response.data.data;
